<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.key"
      :value="true"
      :width="dialog.width"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :persistent="dialog.persistent"
      :retain-focus="false"
      scrollable
      @click:outside="closeOutside(dialog)"
    >
      <v-card>
        <v-card-title class="py-2 px-3 grey lighten-4">
          <v-icon left color="indigo">mdi-puzzle-edit-outline</v-icon>
          <span class="text-subtitle-1 font-weight-medium">{{ dialog.title }}</span>
          <v-spacer />
          <v-btn icon @click="close(dialog.key)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text class="pa-0">
          <ModuleEditor
            v-if="dialog.type === 'module'"
            :module-id="dialog.moduleId"
            :initial-type="dialog.initialType"
            :initial-table="dialog.initialTable"
            :context-key="dialog.contextKey"
            embedded
            @saved="saved(dialog, $event)"
            @close="close(dialog.key)"
          />
          <VariantEditor
            v-else
            :module-id="dialog.moduleId"
            :variant="dialog.variant"
            :context-key="dialog.contextKey"
            embedded
            @saved="saved(dialog, $event)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ModuleEditor from './index.vue'
import VariantEditor from './editVariant.vue'
import { closeModuleEditor, moduleEditorDialogs, notifyModuleSaved } from './navigation'

export default {
  name: 'ModuleEditorDialogHost',

  components: { ModuleEditor, VariantEditor },

  computed: {
    dialogs() {
      return moduleEditorDialogs.items
    },
  },

  methods: {
    close(key) {
      closeModuleEditor(key)
    },
    closeOutside(dialog) {
      if (!dialog.persistent) this.close(dialog.key)
    },
    saved(dialog, module) {
      notifyModuleSaved(dialog.key, module)
    },
  },
}
</script>
